import { useState } from 'react';
import styled from 'styled-components';
import FooterModal from '../../../footer';
import { ProgressBar } from '../../../progressBar';
import { Status } from '../../../status';
import { ImportWrapper } from '../../../styles';
import { CommitmentError } from '../../../types';
import { transactionsSteps } from '../../constants';
import { ImportTransactionsFileData } from '../../types';
import { commitmentsStatusError, commitmentsStatusSuccess } from './constants';
import Table from './table/table';

interface CommitmentsProps {
  importSteps: typeof transactionsSteps;
  prevStep: () => void;
  nextStep: () => void;
  tableData: any;
  transactionTypeErrors: ImportTransactionsFileData[];
  commitmentError: CommitmentError[];
}

export const Commitments = ({ importSteps, prevStep, nextStep, tableData, transactionTypeErrors, commitmentError }: CommitmentsProps) => {
  const [showTable, setShowTable] = useState(false);

  return (
    <>
      <ImportWrapper>
        <ProgressBar importSteps={importSteps} />
        <Status
          errorsCount={commitmentError.length || null}
          matched={[{ count: tableData.length, text: 'Matched' }]}
          showTable={showTable}
          setShowTable={setShowTable}
          startOver={prevStep}
          confirmButton={{ name: 'Save and Complete', onClick: nextStep, disabled: Boolean(commitmentError.length || transactionTypeErrors.length) }}
          success={commitmentsStatusSuccess}
          error={commitmentsStatusError}
        />
      </ImportWrapper>
      {showTable || commitmentError?.length ? (
        <TableWrapper>
          <Table tableData={tableData} commitmentError={commitmentError} />
        </TableWrapper>
      ) : (
        <></>
      )}
      {commitmentError?.length || showTable ? (
        <FooterModal
          startOver={prevStep}
          startOverButtonName="Back"
          confirmButton={{ name: 'Save and Complete', onClick: nextStep, disabled: Boolean(commitmentError.length || transactionTypeErrors.length) }}
        />
      ) : (
        <></>
      )}
    </>
  );
};

const TableWrapper = styled.div`
  margin-bottom: 100px;
`;
